import React from "react";
import { Box } from "@mui/material";
import { PortfolioDataChatPanel } from "../components/portfolio/PortfolioDataChatPanel";

/**
 * Standalone portfolio data chat (same session/UI as legacy portfolio FAB, route `/ai-chatbot`).
 */
const AiChatbotPage: React.FC = () => {
  return (
    <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
      <PortfolioDataChatPanel variant="standalone-page" />
    </Box>
  );
};

export default AiChatbotPage;
